export const meta = {
  title: 'Жилье по льготной стоимости',
  description: 'Порядок предоставления арендного жилья по льготной стоимости.',
};

export const orderData = [
  {
    mainInfo:
      'Для включения гражданина в Список претендентов на арендное жилье, по льготной' +
      'стоимости (по ставке не превышающей 50% от рыночной стоимости) на территории' +
      'Сахалинской области (далее – Список) необходимо обращаться в администрацию' +
      'муниципального образования (далее- Администрация), в котором требуется арендное' +
      'жилье. Работодателю необходимо направить на имя главы Администрации документы:',
    documentsNamesList:
      '- ходатайство Заявителя (работодателя) о включении гражданина в Список, с ' +
      'подтверждением отсутствия у гражданина и членов его семьи жилых помещений на ' +
      'территории муниципального образования (по договору специализированного, в том числе ' +
      'служебного найма, договорам найма жилых помещений жилищного фонда социального ' +
      'использования);<br />' +
      '- заявление гражданина на имя главы муниципального образования о включении в Список, по утвержденной' +
      ' форме;<br />' +
      '- документ, удостоверяющий личность ' +
      'гражданина, при наличии членов семьи, которые будут проживать с ним совместно — ' +
      'документы, подтверждающие личность каждого члена семьи (копии всех страниц документа);<br />' +
      '- документы, подтверждающие родственные отношения (свидетельство о регистрации брака, ' +
      'свидетельство о рождении, решение суда) (копии) – на одиноко проживающего не ' +
      'распространяется;<br />' +
      '- трудовой договор (копия, заверенная отделом кадров/специалистом по ' +
      'кадровым вопросам по месту осуществления трудовой деятельности гражданина);<br />' +
      '- свидетельство о постановке на учет в налоговом органе физического лица по месту ' +
      'жительства на территории Российской Федерации (копия);<br />' +
      '- страховое свидетельство государственного пенсионного страхования (копия);<br />' +
      '- договор специализированного, в том ' +
      'числе служебного найма, договор найма жилых помещений жилищного фонда социального ' +
      'использования (копии) (в случае заключения таких договоров);<br />' +
      '- справка организации, осуществляющей образовательную деятельность, полученная не ранее 30 дней до даты ' +
      'подачи Заявителем в администрацию муниципального образования соответствующего пакета ' +
      'документов (в случае наличия у гражданина ребенка в возрасте до 23 лет, обучающегося в ' +
      'соответствующей организации);<br />' +
      '- согласие на обработку персональных данных всех членов ' +
      'семьи, в отношении которых предоставляются документы для включения в Список, по ' +
      'утвержденной форме.',
    additionalInfo:
      'Консультацию представители работодателя-заявителя либо работники могут получить в ' +
      'Администрации муниципального образования, в котором требуется арендное жилье.' +
      '<br /><br />' +
      'После проверки документов кандидата Администрация направляет в адрес Агентства ' +
      'ходатайство на право заключения договора коммерческого найма по льготной стоимости. На ' +
      'основании ходатайства кандидата заключаем договор коммерческого найма квартиры по ' +
      'льготной стоимости.<br /><br />',
  },
  {
    mainInfo:
      'Не реже 1 раза в 6 месяцев (по запросу Агентства Администрацией муниципального образования осуществляется ' +
      'проверка соответствия нанимателей установленным критериям. В целях подтверждения права нанимателей на арендное жилье ' +
      'Вам будет необходимо предоставлять в адрес Агентства следующие документы:',
    documentsNamesList:
      '- ходатайство Заявителя о перезаключении договора с гражданином;<br />' +
      '- справку с места работы об осуществлении трудовой деятельности, полученную не ранее 30 дней до обращения Заявителя;<br />' +
      '- справку организации, осуществляющей образовательную деятельность, полученную не ранее 30 дней до даты подачи ' +
      'Заявителем в Администрацию соответствующего пакета документов (в случае наличия у гражданина ребенка в возрасте до 23 лет, обучающегося в соответствующей организации);<br />' +
      '- справку о составе семьи, полученную не ранее 30 дней до обращения.<br /><br />',
  },
  {
    mainInfo:
      'В случае, если специалист, которому на основании ходатайства предоставлено арендное жилье, ' +
      'расторг трудовые отношения, и после увольнения квартира освобождена таким специалистом, но оставлена в арендном ' +
      'жилом фонде лимита Администрации - Работодателю будет предоставлено первоочередное право ходатайствовать о ' +
      'заселении в данную квартиру иного специалиста Вашей организации, при условии предоставления в течение трех ' +
      'рабочих дней с даты поступления соответствующей информации от Администрации следующих документов:',
    documentsNamesList:
      '- ходатайства о заключении договора коммерческого найма с гражданином;<br />' +
      '- согласия гражданина на заселение в распределяемое жилое помещение;<br />' +
      '- справки с места работы об осуществлении трудовой деятельности, полученную не ранее 30 дней до обращения Заявителя;<br />' +
      '- справки организации, осуществляющей образовательную деятельность, полученную не ранее 30 дней до даты подачи ' +
      'Заявителем в Администрацию соответствующего пакета документов (в случае наличия у гражданина ребенка в возрасте ' +
      'до 23 лет, обучающегося в соответствующей организации);<br />' +
      '- справки о составе семьи, полученную не ранее 30 дней до обращения гражданина.',
    additionalInfo:
      'В случае утраты права найма арендного жилья по льготной ставке (несоответствия критериям, установленным Порядком) ' +
      'и неполучения в этой связи Агентством ходатайства по установленной форме, наниматель сохраняет возможность заключения ' +
      'договора коммерческого найма по полной рыночной ставке. В данном случае право на выкуп арендного жилья также сохраняется за нанимателем.<br />' +
      'В случае непредоставления ходатайства и незаключения с Агентством договора коммерческого найма по полной рыночной цене, ' +
      'нанимателю необходимо в указанный срок освободить занимаемое жилое помещение и передать его по акту приема-передачи представителю Агентства.',
  },
];
